// import {
//   getAccountFreghtList,
//   getFreightMasterApi,
//   getUserAccountList,
//   getVenderBankList,
//   handleKeyDown,
//   uploadFiles,
// } from "_services";
// import {
//   CommonCanvas,
//   CommonDatePicker,
//   CommonInput,
//   CommonModal,
//   CustomSelect,
//   SkeletonInput,
// } from "components";
// import { UserContext } from "context";
// import { addTransationConsignor, addTransationFreight } from "features";
// import { errorSchema, utils } from "helper";
// import moment from "moment";
// import React, { useContext, useEffect, useState } from "react";
// import toast from "react-hot-toast";
// import { IoCloseCircle } from "react-icons/io5";
// import { useDispatch } from "react-redux";
// import StorageService from "utils/StorageServices/StorageServices";

// const AddChargeModal = (props) => {
//   const { lrDetails, callBackCharge } = props;


//   const initiFrom = {
//     category: "",
//     sub_category: "",
//     expense_category: "",
//     amount: "",
//     txn_date: new Date(),
//     account_category: "",
//     account_sub_category: "",
//     account_id: "",
//     description: "",
//     vendor_type: "",
//     vendor_account: "",
//     lr_id: "",
//     trip_id: props?.tripId,
//     branch_id: "",
//     company_id: StorageService.getCompanyId(),
//     vehicle_id: "",
//     file: [],
//   };
//   const dispatch = useDispatch();
//   const {
//     masterData,
//     globTripDetails,
//     bankDetails,
//     setBankDetails,
//     modalZIndex,
//     setModalZIndex,
//   } = useContext(UserContext);
//   const [form, setForm] = useState(initiFrom);
//   const [formError, setFormError] = useState("");
//   const [freightTypeList, setFreightTypeList] = useState([]);
//   const [freigtAccount, setFreigtAccount] = useState([]);
//   const [venderBankList, setVenderBankList] = useState([]);
//   const [accountList, setAccountList] = useState([]);
//   const [isCheck, setIsCheck] = useState(bankDetails ? true : false);
//   const [bankAccountList, setBankAccountList] = useState([]);
//   const [isLoadding, setIsLoadding] = useState(false);
//   const [accountType, setAccountType] = useState();
//   const [accountLoading,setAccountLoading] = useState(false)
//   const [loading, setLoading] = useState(false);
//   const [isLoadingSave,setIsLoadingSave]= useState(false)



//   const styleZindex = {
//     zIndex: -1,
//   };
//   useEffect(() => {
//     if (props?.isOpen) {
//       getMasterFreight();
//     }
//   }, [props?.isOpen]);

//   useEffect(() => {
//     if (!isCheck) {
//       setBankDetails("");


//     }
//   }, [isCheck]);

//   useEffect(() => {
//     if ( form?.sub_category == 2) {

//       setForm((prev) => {
//         const updatedAmount =
//           form?.sub_category == 2
//             ? lrDetails?.lr_freight?.balance||prev?.amount|| 0
//             : prev?.amount;

//         return {
//           ...prev,
//           amount: updatedAmount,
//         };
//       });
//     }
//   }, [form?.sub_category]);


//   useEffect(() => {
//     if (form?.account_sub_category && form?.account_category && freigtAccount.length){
//       if(form?.account_id==""){

//         getAccountListHandler();
//       }
//     }

//   }, [form?.account_sub_category, form?.account_category,freigtAccount,form?.account_id]);

//   useEffect(() => {
//     if (form?.category) {
//       getVenderBankHandler();
//     }
//   }, [form?.category]);

//   // useEffect(() => {
//   //   if (form?.account_sub_category && form?.account_category){
//   //     getAccountListHandler();
//   //   }

//   // }, [form?.account_sub_category, form?.account_category]);

//   useEffect(() => {
//     if (accountType) {
//       setForm({ ...form, account_id: "", vendor_account: "" });
//       setBankDetails("");
//     }
//   }, [accountType]);

//   useEffect(() => {
//     if (props?.accountList?.length > 0) {
//       let list = props?.accountList?.map((i) => {
//         return {
//           ...i,
//           label: i?.bank_name ? i?.bank_name : i?.upi_id,
//           value: i?._id,
//         };
//       });
//       setBankAccountList(list);
//     }
//   }, [props?.accountList]);

//   const getMasterFreight = async () => {
//     const payload = {
//       type: "add_freight",
//     };

//     try {
//       const details = masterData?.party_freights?.sub_type?.map((item) => {
//         return {
//           label: item?.name,
//           value: item?.id,
//           id: item?._id,
//           status: item?.status,
//           category_id: masterData?.party_freights?.id,
//           type: masterData?.party_freights?.type,
//         };
//       });

//       const detailsAccountOwn = masterData?.own_account_category?.sub_category?.filter((k) => k.id !== 10)?.map(
//         (item) => {
//           return {
//             label: item?.name,
//             value: item?.id,
//             category_id: masterData?.own_account_category?.id,
//           };
//         }
//       );

//       const detailsAccount = masterData?.market_account_category?.sub_category
//         ?.filter((k) => k.id !== 10)
//         ?.reverse()
//         ?.map((item) => {
//           return {
//             label: item?.name,
//             value: item?.id,
//             category_id: masterData?.market_account_category?.id,
//           };
//         });

//         const order = [ "Cash", "Bank", "Other"];
//         const sortedData = detailsAccount.sort((a, b) => order.indexOf(a.label) - order.indexOf(b.label));

//       if (detailsAccount && details) {
//         setForm({
//           ...form,
//           trip_id: props?.tripId,
//           category:
//             details[props?.isOpenCharge?.type === "advance" ? 0 : 1]?.category_id,
//           sub_category: details[props?.isOpenCharge?.type === "advance" ? 0 : 1]?.value,
//           account_category: globTripDetails?.vehicle_ownership == 2?sortedData[0]?.category_id:detailsAccountOwn[0]?.category_id,
//           account_sub_category:globTripDetails?.vehicle_ownership == 2?sortedData[0]?.value:detailsAccountOwn[0]?.value,
//         });

//         setFreigtAccount(globTripDetails?.vehicle_ownership == 2?sortedData:detailsAccountOwn);
//         setFreightTypeList(details);

//       }
//       // }
//     } catch {}
//   };

//   const getVenderBankHandler = async () => {
//     try {
//       const res = await getVenderBankList({
//         company_id: StorageService?.getCompanyId(),
//         department: 1,
//         department_id: globTripDetails?.supplier_id?._id,
//       });

//       if (res?.responseCode === 200) {
//         const details = res?.data?.bank_account?.map((item) => {
//           return {
//             ...item,
//             label: item?.bank_name,
//             value: item?._id,
//           };
//         });
//         setForm({ ...form, vendor_type: 1 });
//         setVenderBankList(details);
//       } else {
//         console.log(res?.payload?.data?.responseMessage);
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const getAccountListHandler = async () => {
//     setAccountLoading(true)
//     try {
//       const res = await getUserAccountList({
//         company_id: StorageService?.getCompanyId(),
//         category_id: parseInt(form?.account_category),
//         sub_category_id: parseInt(form?.account_sub_category),
//         // account_id: "",
//       });

//       if (res?.responseCode === 200) {
//         setAccountLoading(false)
//         const details = res?.data?.account_list?.map((item) => {
//           return {
//             ...item,
//             label: item?.name,
//             value: item?._id,
//           };
//         });
//         setAccountList(details);

//         setForm((prev) => {
//           const updatedAmount =
//             form?.sub_category === 2
//               ? lrDetails?.lr_freight?.balance||prev?.amount || 0
//               : prev?.amount;

//           return {
//             ...prev,
//             account_id: details[0]?.value || "",
//             amount: updatedAmount,
//           };
//         });

//       } else {
//         setAccountLoading(false)
//         setAccountList([]);
//       }
//     } catch (error) {
//       console.log(error);
//       setAccountLoading(false)
//       setAccountList([]);
//     }
//   };

//   const handleOnChange = async (name, value) => {
//     const stateObj = {
//       ...form,
//       [name]: value,
//     };
//     setForm(stateObj);

//     if (!!formError) {
//       const validationResult = await utils.checkFormError(
//         { ...stateObj },
//         errorSchema.addChargeSchema
//       );
//       if (validationResult === true) {
//         setFormError("");
//       } else {
//         setFormError(validationResult);
//       }
//     }
//   };

//   const validateInput = (value) => {
//     const number = parseFloat(value);
//     return (
//       number <=
//       props?.transactionList?.freight_summary?.freight_summary?.balance
//     );
//   };

//   const handleFileChange = async (e) => {
//     if (
//       e?.target?.files[0]?.type === "image/gif" ||
//       e?.target?.files[0]?.type === "image/jpeg" ||
//       e?.target?.files[0]?.type === "image/png"
//     ) {
//       setLoading(true);
//       try {
//         const formData = new FormData();
//         formData.append("file", e?.target?.files[0]);
//         const res = await uploadFiles(formData);
//         if (res?.responseCode === 200) {
//           var fileArray = [];
//           fileArray.push(...form?.file, {
//             filename: res?.data?.filename,
//             path: res?.data?.path,
//           });
//           handleOnChange("file", fileArray);
//           // setFormValue((s) => ({ ...s, file: fileArray }));
//           setLoading(false);
//           toast.success("Document added ");
//         }
//       } catch (error) {
//         setLoading(false);
//       }
//     } else {
//       toast.error("Invalid file, choose jpeg/png images");
//     }
//   };

//   const onSubmitFreight = async (approve) => {
//     const validationResult = await utils.checkFormError(
//       { ...form },
//       errorSchema.addChargeSchema
//     );

//     const payload = {
//       type: form?.category ? parseInt(form?.category) : "",
//       sub_type: form?.sub_category ? parseInt(form?.sub_category) : "",
//       expense_category: form?.expense_category,
//       amount: (form?.amount).toString(),
//       date: utils.convertToISO(form?.txn_date,true),
//       account_category: form?.account_category
//         ? parseInt(form?.account_category)
//         : "",
//       account_sub_category: form?.account_sub_category
//         ? parseInt(form?.account_sub_category)
//         : "",
//       account_id: form?.account_id ? form?.account_id : "",
//       description: form?.description,
//       // vendor_type: 2,
//       // vendor_id: lrDetails?.consignor_id?._id,
//       vendor_bank_account: bankDetails ? bankDetails?._id : "",
//       lr_id: lrDetails?._id,
//       trip_id: props.tripId,
//       // branch_id: globTripDetails?.branch_id?._id,
//       company_id: form?.company_id,
//       // vehicle_id: globTripDetails?.vehicle_id?._id,
//       is_approval: approve,
//       file: form?.file,
//     };


//     if (validationResult === true) {
//       approve == 0 ? setIsLoadding(true) : setIsLoadingSave(true);
//       try {
//         const res = await dispatch(addTransationConsignor(payload));
//         if (res?.payload?.responseCode === 200) {
//           setIsLoadding(false);
//           setIsLoadingSave(false);
//           callBackCharge();
//         }else{

//           setIsLoadding(false);
//           setIsLoadingSave(false);
//         }
//       } catch {

//         setIsLoadding(false);
//         setIsLoadingSave(false);
//       }
//     } else {
//       setFormError(validationResult);
//       setIsLoadding(false);
//       setIsLoadingSave(false);
//     }
//   };


//   const documentRemove = (index) =>{
//     const newFromIput = [...form?.file];

//     newFromIput.splice(index, 1);

//     setForm({...form,file:newFromIput});
//   }

//   const modifyProps = {
//     ...props,
//     modalTitle:form?.sub_category==1?"Add Advance Freight":"Add Balance Freight",
//     onSubmit: onSubmitFreight,
//     isLoadding: isLoadding,
//     disabled: isLoadding,
//     isLoadingSave:isLoadingSave
//   };


//   return (
//     <div>
//       <CommonCanvas {...modifyProps}>
//         <div className="offcanvas-body">
//           <div className="_lrCl_offCavBody">
//             <div className="_othrExp_recBx">
//               <div className="checkBx_lv">
//                 {freightTypeList.map((i) => {
//                   return (
//                     <div className="_dualCheckr_bx">
//                       <input
//                         className="form-check-input"
//                         id={i.value}
//                         type="radio"
//                         name="sub_category"
//                         checked={i.value == form.sub_category}
//                         value={i.value}
//                         onChange={({ target: { name, value } }) =>
//                           handleOnChange(name, value)
//                         }
//                       />
//                       <label for={i.value} className="form-check-label">
//                         {i?.label}
//                       </label>
//                     </div>
//                   );
//                 })}
//                 {/* <div className="_dualCheckr_bx" >
//                           <input className="form-check-input" id="receipt" type="radio" name="otrExpRec" value="2" />
//                           <label for="receipt" className="form-check-label">Receipt</label>
//                         </div> */}
//               </div>
//             </div>
//             <div className="_clPay_flex">
//               <div className="singleDiv">
//                 <CommonInput
//                   type="text"
//                   label="Amount (₹)"
//                   placeholder="Amount"
//                   name="amount"
//                   className="__rupeeSymbol"
//                   rupeeSymbol={true}
//                   value={form.amount}

//                   onChange={({ target: { name, value } }) => {
//                     if (/^\d*$/.test(value)) {
//                       handleOnChange(name, value);
//                     }
//                   }}
//                   maxLength={10}

//                   focus={!!formError?.amount}
//                   error={formError.amount}
//                 />
//               </div>

//               <div className="singleDiv">
//                 <CommonDatePicker
//                   name="date"
//                   label="Transaction Date"
//                   startDate={form?.txn_date}
//                   setStartDate={(data) => {
//                     handleOnChange("txn_date", data);
//                   }}
//                   error={formError?.txn_date}
//                   focus={!!formError?.txn_date}
//                 />
//               </div>

//               <div className="singleDiv">
//                 <CommonInput
//                   type="text"
//                   label="Description"
//                   placeholder="Description"
//                   name="description"
//                   value={form?.description}
//                   onChange={({ target: { name, value } }) => {
//                     handleOnChange(name, value);
//                   }}
//                   focus={!!formError?.description}
//                   error={formError.description}
//                 />
//               </div>

//               <div className="singleDiv">
//                 <div className="_payMode_hed">
//                   <h4>Payment Mode</h4>
//                   {freigtAccount.map((i) => (
//                     <button
//                       className={`_baseSpan ${
//                         i?.value == form?.account_sub_category
//                           ? ""
//                           : "_bspDisable"
//                       }`}
//                       disabled={accountLoading}
//                       name="account_sub_category"
//                       value={i.value}
//                       onClick={({ target: { name, value } }) => {
//                         handleOnChange(name, value);
//                         setAccountType(value);
//                       }}
//                     >
//                       {i.label}
//                     </button>
//                   ))}
//                   {/* <span className='_baseSpan _bspDisable'>Bank Transfer</span> */}
//                 </div>
//               </div>

//               {form?.account_sub_category != 11 && 
//             <>
//               {!accountLoading?<div className="singleDiv">
//                 <CustomSelect
//                   label="Select Account"
//                   name="account_id"
//                   onSelect={(data) => {
//                     handleOnChange("account_id", data.value);
//                   }}
//                   value={
//                     form?.account_id
//                       ? accountList?.find((i) => i.value == form?.account_id)
//                       : { label: "", value: "" }
//                   }
//                   options={accountList}
//                   focus={!!formError?.account_id}
//                   error={formError.account_id}
//                 />
//               </div>:<SkeletonInput isLoading={accountLoading} />}
//             </>
// }

// {form?.account_sub_category == 11 && (
//                         <div>
//                           Driver - {globTripDetails?.driver_id?.name} 
//                         </div>
//                       )}
//               <div className="singleDiv">
//                   <div className="_attatchmentBxs">
//                     <h4>Attachment</h4>

//                     <div className="_athBxs">
//                       <input
//                         type="file"
//                         id="_fileUpload"
//                         onChange={(e) => handleFileChange(e)}
//                         disabled={loading || form?.file?.length >= 5}
//                       />
//                       <label htmlFor="_fileUpload" className="_uploadBtn">
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="20"
//                           height="19"
//                           viewBox="0 0 20 19"
//                           fill="none"
//                         >
//                           <path
//                             d="M5 0C6.28846 7.44425e-05 7.52716 0.497542 8.45778 1.38866C9.38839 2.27978 9.93908 3.49575 9.995 4.783L10 5V16C10.0008 16.7809 9.69698 17.5313 9.15323 18.0918C8.60948 18.6523 7.86861 18.9787 7.08804 19.0016C6.30747 19.0245 5.54873 18.7422 4.97303 18.2145C4.39733 17.6869 4.05006 16.9556 4.005 16.176L4 16V6C4.00028 5.74512 4.09788 5.49997 4.27285 5.31463C4.44782 5.1293 4.68695 5.01776 4.94139 5.00283C5.19584 4.98789 5.44638 5.07067 5.64183 5.23426C5.83729 5.39785 5.9629 5.6299 5.993 5.883L6 6V16C6.00028 16.2549 6.09788 16.5 6.27285 16.6854C6.44782 16.8707 6.68695 16.9822 6.94139 16.9972C7.19584 17.0121 7.44638 16.9293 7.64183 16.7657C7.83729 16.6021 7.9629 16.3701 7.993 16.117L8 16V5C8.00075 4.21909 7.69698 3.46867 7.15323 2.90818C6.60948 2.34769 5.86861 2.02132 5.08804 1.9984C4.30747 1.97548 3.54873 2.25784 2.97303 2.78546C2.39733 3.31309 2.05006 4.0444 2.005 4.824L2 5V14C1.99972 14.2549 1.90212 14.5 1.72715 14.6854C1.55218 14.8707 1.31305 14.9822 1.05861 14.9972C0.804163 15.0121 0.553621 14.9293 0.358167 14.7657C0.162714 14.6021 0.0371036 14.3701 0.00699997 14.117L0 14V5C0 3.67392 0.526784 2.40215 1.46447 1.46447C2.40215 0.526784 3.67392 0 5 0ZM13 14H15C15.2549 14.0003 15.5 14.0979 15.6854 14.2728C15.8707 14.4478 15.9822 14.687 15.9972 14.9414C16.0121 15.1958 15.9293 15.4464 15.7657 15.6418C15.6021 15.8373 15.3701 15.9629 15.117 15.993L15 16H13C12.7451 15.9997 12.5 15.9021 12.3146 15.7272C12.1293 15.5522 12.0178 15.313 12.0028 15.0586C11.9879 14.8042 12.0707 14.5536 12.2343 14.3582C12.3979 14.1627 12.6299 14.0371 12.883 14.007L13 14ZM13 10H18.5C18.7549 10.0003 19 10.0979 19.1854 10.2728C19.3707 10.4478 19.4822 10.687 19.4972 10.9414C19.5121 11.1958 19.4293 11.4464 19.2657 11.6418C19.1021 11.8373 18.8701 11.9629 18.617 11.993L18.5 12H13C12.7451 11.9997 12.5 11.9021 12.3146 11.7272C12.1293 11.5522 12.0178 11.313 12.0028 11.0586C11.9879 10.8042 12.0707 10.5536 12.2343 10.3582C12.3979 10.1627 12.6299 10.0371 12.883 10.007L13 10ZM13 6H18.5C18.7549 6.00028 19 6.09788 19.1854 6.27285C19.3707 6.44782 19.4822 6.68695 19.4972 6.94139C19.5121 7.19584 19.4293 7.44638 19.2657 7.64183C19.1021 7.83729 18.8701 7.9629 18.617 7.993L18.5 8H13C12.7451 7.99972 12.5 7.90212 12.3146 7.72715C12.1293 7.55218 12.0178 7.31305 12.0028 7.05861C11.9879 6.80416 12.0707 6.55362 12.2343 6.35817C12.3979 6.16271 12.6299 6.0371 12.883 6.007L13 6ZM13 2H18.5C18.7549 2.00028 19 2.09788 19.1854 2.27285C19.3707 2.44782 19.4822 2.68695 19.4972 2.94139C19.5121 3.19584 19.4293 3.44638 19.2657 3.64183C19.1021 3.83729 18.8701 3.9629 18.617 3.993L18.5 4H13C12.7451 3.99972 12.5 3.90212 12.3146 3.72715C12.1293 3.55218 12.0178 3.31305 12.0028 3.05861C11.9879 2.80416 12.0707 2.55362 12.2343 2.35817C12.3979 2.16271 12.6299 2.0371 12.883 2.007L13 2Z"
//                             fill="#1956F6"
//                           />
//                         </svg>
//                         <span>{loading ? "Uploadding" : "Add File"}</span>
//                       </label>
//                       {formError?.file && (
//                         <span className="input_drop_error">
//                           {formError?.file}
//                         </span>
//                       )}
//                     </div>
//                     <div className="img_fnex_src">
//                       {form?.file?.length > 0 &&
//                         form?.file?.map((el,index) => {
//                           return (
//                             <>
//                                 <div className='pos-relative'>
//                                     <img className='_pdfIcon_sigxe'
//                                         src={`${masterData?.s3_url}${el?.path}`}
//                                         alt=""
//                                     />
//                                     <span className='_clDel_icon'>
//                                     <IoCloseCircle onClick={()=>documentRemove(index)}/>
//                                     </span>
//                                 </div>
//                             </>
//                         )
//                         })}
//                     </div>
//                   </div>
//                 </div>
//             </div>
//           </div>
//         </div>
//       </CommonCanvas>
//     </div>
//   );
// };

// export default AddChargeModal;

import {
  getAccountFreghtList,
  getFreightMasterApi,
  getUserAccountList,
  getVenderBankList,
  handleKeyDown,
  uploadFiles,
} from "_services";
import {
  CommonCanvas,
  CommonDatePicker,
  CommonInput,
  CommonModal,
  CustomSelect,
  SkeletonInput,
} from "components";
import { UserContext } from "context";
import { addTransationConsignor, addTransationFreight } from "features";
import { errorSchema, utils } from "helper";
import moment from "moment";
import React, { useContext, useEffect, useState, useCallback, useMemo } from "react";
import toast from "react-hot-toast";
import { IoCloseCircle } from "react-icons/io5";
import { useDispatch } from "react-redux";
import StorageService from "utils/StorageServices/StorageServices";

const AddChargeModal = (props) => {
  const { lrDetails, callBackCharge, tripId, isOpenCharge, isOpen ,tripDetais} = props;

  // Memoized initial form state
  const initialForm = useMemo(() => ({
    category: "",
    sub_category: "",
    expense_category: "",
    amount: "",
    txn_date: new Date(),
    account_category: "",
    account_sub_category: "",
    account_id: "",
    description: "",
    vendor_type: "",
    vendor_account: "",
    lr_id: "",
    trip_id: tripId,
    branch_id: "",
    company_id: StorageService.getCompanyId(),
    vehicle_id: "",
    file: [],
  }), [tripId]);

  const dispatch = useDispatch();
  const {
    masterData,
    globTripDetails,
    bankDetails,
    setBankDetails,
    modalZIndex,
    setModalZIndex,
  } = useContext(UserContext);

  // State management
  const [form, setForm] = useState(initialForm);
  const [formError, setFormError] = useState({});
  const [freightTypeList, setFreightTypeList] = useState([]);
  const [freigtAccount, setFreigtAccount] = useState([]);
  const [venderBankList, setVenderBankList] = useState([]);
  const [accountList, setAccountList] = useState([]);
  const [isCheck, setIsCheck] = useState(Boolean(bankDetails));
  const [bankAccountList, setBankAccountList] = useState([]);
  const [isLoadding, setIsLoadding] = useState(false);
  const [accountType, setAccountType] = useState();
  const [accountLoading, setAccountLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);
  const [bankRequiredDetails, setBankRequiredDetails] = useState({})


  // Reset form when modal opens
  useEffect(() => {
    if (isOpen) {
      setForm(initialForm);
      setFormError({});
      setFreightTypeList([]);
      setFreigtAccount([]);
      setVenderBankList([]);
      setAccountList([]);
      setAccountType(undefined);
      getMasterFreight();
    }
  }, [isOpen, initialForm]);

  // Handle bank details checkbox
  useEffect(() => {
    if (!isCheck) {
      setBankDetails("");
    }
  }, [isCheck, setBankDetails]);

  // Update amount for balance freight (sub_category == 2)
  useEffect(() => {
    if (form?.sub_category == 2 && lrDetails?.lr_freight?.balance !== undefined) {
      setForm(prev => ({
        ...prev,
        amount: lrDetails.lr_freight.balance.toString()
      }));
      handleOnChange("amount", lrDetails.lr_freight.balance.toString());
    }
  }, [form?.sub_category, lrDetails?.lr_freight?.balance]);

  // Get account list when category changes
  useEffect(() => {
    if (form?.account_sub_category && form?.account_category && freigtAccount.length) {
      if (form?.account_id == "") {

        getAccountListHandler();
      }

    }
  }, [form?.account_sub_category, form?.account_category, freigtAccount, form.account_id]);

  // Get vendor bank details
  // useEffect(() => {
  //   if (form?.category) {
  //     getVenderBankHandler();
  //   }
  // }, [form?.category]);

  // Reset account when account type changes
  useEffect(() => {
    if (accountType) {
      setForm(prev => ({
        ...prev,
        account_id: "",
        vendor_account: ""
      }));
      setBankDetails("");
    }
  }, [accountType, setBankDetails]);

  // Process bank account list
  useEffect(() => {
    if (props?.accountList?.length > 0) {
      const list = props.accountList.map(item => ({
        ...item,
        label: item?.bank_name || item?.account_name || item?.upi_id,
        value: item?._id,
      }));
      setBankAccountList(list);
    }
  }, [props?.accountList]);

  const getMasterFreight = useCallback(async () => {
    try {
      if (!masterData?.party_freights?.sub_type) {
        console.warn("Master data not available");
        return;
      }

      const details = masterData.party_freights.sub_type.map(item => ({
        label: item?.name,
        value: item?.id,
        id: item?._id,
        status: item?.status,
        category_id: masterData?.party_freights?.id,
        type: masterData?.party_freights?.type,
      }));

      const detailsAccountOwn = masterData?.own_account_category?.sub_category
        ?.filter(k => k.id !== 10  && k.id !==28)
        ?.map(item => ({
          label: item?.name,
          value: item?.id,
          category_id: masterData?.own_account_category?.id,
        })) || [];

      const detailsAccount = masterData?.market_account_category?.sub_category
        ?.filter(k => k.id !== 10 && k.id !==28)
        ?.reverse()
        ?.map(item => ({
          label: item?.name,
          value: item?.id,
          category_id: masterData?.market_account_category?.id,
        })) || [];

      const order = [3, 2, 27, 14];
      const sortedData = detailsAccount.sort((a, b) => order.indexOf(a.value) - order.indexOf(b.value));

      const isMarketVehicle = globTripDetails?.vehicle_ownership === 2;
      const selectedAccount = isMarketVehicle ? sortedData : detailsAccountOwn;
      const isAdvance = isOpenCharge?.type === "advance";

      if (selectedAccount.length > 0 && details.length > 0) {
        setForm(prev => ({
          ...prev,
          trip_id: tripId,
          category: details[isAdvance ? 0 : 1]?.category_id,
          sub_category: details[isAdvance ? 0 : 1]?.value,
          account_category: selectedAccount[0]?.category_id,
          account_sub_category: selectedAccount[0]?.value,
        }));

        setFreigtAccount(selectedAccount);
        setFreightTypeList(details);
      }
    } catch (error) {
      console.error("Error in getMasterFreight:", error);
      toast.error("Failed to load freight data");
    }
  }, [masterData, globTripDetails?.vehicle_ownership, isOpenCharge?.type, tripId]);

  const getVenderBankHandler = useCallback(async () => {
    if (!globTripDetails?.supplier_id?._id) {
      console.warn("Supplier ID not available");
      return;
    }

    try {
      const res = await getVenderBankList({
        company_id: StorageService?.getCompanyId(),
        department: 1,
        department_id: globTripDetails.supplier_id._id,
      });

      if (res?.responseCode === 200) {
        const details = res?.data?.bank_account?.map(item => ({
          ...item,
          label: item?.bank_name,
          value: item?._id,
        })) || [];

        setForm(prev => ({ ...prev, vendor_type: 1 }));
        setVenderBankList(details);
      } else {
        console.log("Failed to fetch vendor bank details:", res?.responseMessage);
      }
    } catch (error) {
      console.error("Error in getVenderBankHandler:", error);
      toast.error("Failed to load vendor bank details");
    }
  }, [globTripDetails?.supplier_id?._id]);

  const getAccountListHandler = useCallback(async () => {
    if (!form?.account_category || !form?.account_sub_category) {
      return;
    }

    setAccountLoading(true);
    try {
      const res = await getUserAccountList({
        company_id: StorageService?.getCompanyId(),
        category_id: parseInt(form.account_category),
        sub_category_id: parseInt(form.account_sub_category),
         firm_id:tripDetais?.firm_id?._id
      });

      if (res?.responseCode === 200) {
        const details = res?.data?.account_list?.map(item => ({
          ...item,
          label: item?.name,
          value: item?._id,
        })) || [];

        setAccountList(details);
        setBankRequiredDetails(details[0])

        if (details.length > 0) {
          setForm(prev => ({
            ...prev,
            account_id: details[0].value,
            // amount: prev.sub_category === 2
            //   ? (lrDetails?.lr_freight?.balance || prev.amount || 0).toString()
            //   : prev.amount,
          }));
        }
        const validationResult = await utils.checkFormError(
          { account_id: details[0].value },
          errorSchema.addChargeSchema.pick(['account_id'])
        );

        if (validationResult === true) {
          setFormError({});
        } else {
          setFormError(validationResult);
        }
      } else {
        setAccountList([]);
        toast.error("Failed to load account list");
      }
    } catch (error) {
      console.error("Error in getAccountListHandler:", error);
      setAccountList([]);
      // toast.error("Error loading account list");
    } finally {
      setAccountLoading(false);
    }
  }, [form?.account_category, form?.account_sub_category, lrDetails?.lr_freight?.balance]);

  const handleOnChange = useCallback(async (name, value) => {
    const stateObj = { ...form, [name]: value };
    setForm(stateObj);

    if (formError[name]) {
      setFormError(prev => ({ ...prev, [name]: "" }));
    }
    if (!!formError) {
      const validationResult = await utils.checkFormError(
        { ...stateObj, balance: lrDetails.lr_freight.balance },
        errorSchema.addChargeSchema
      );
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }

    // // Clear specific field error when user starts typing


    // // Validate entire form if there are existing errors
    // if (Object.keys(formError).length > 0) {
    //   try {
    //     const validationResult = await utils.checkFormError(
    //       stateObj,
    //       errorSchema.addChargeSchema
    //     );
    //     if (validationResult === true) {
    //       setFormError({});
    //     } else {
    //       setFormError(validationResult);
    //     }
    //   } catch (error) {
    //     console.error("Validation error:", error);
    //   }
    // }
  }, [form, formError]);

  const handleFileChange = useCallback(async (e) => {
    const file = e?.target?.files?.[0];
    if (!file) return;

    const allowedTypes = ["image/gif", "image/jpeg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      toast.error("Invalid file type. Please choose JPEG/PNG/GIF images");
      return;
    }

    if (form?.file?.length >= 5) {
      toast.error("Maximum 5 files allowed");
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const res = await uploadFiles(formData);

      if (res?.responseCode === 200) {
        const newFile = {
          filename: res?.data?.filename,
          path: res?.data?.path,
        };

        setForm(prev => ({
          ...prev,
          file: [...prev.file, newFile]
        }));

        toast.success("Document added successfully");
      } else {
        toast.error("Failed to upload file");
      }
    } catch (error) {
      console.error("File upload error:", error);
      toast.error("Error uploading file");
    } finally {
      setLoading(false);
      // Reset file input
      e.target.value = "";
    }
  }, [form?.file]);

  const onSubmitFreight = useCallback(async (approve) => {
    try {
      const validationResult = await utils.checkFormError(
        {
          ...form,
          balance: lrDetails.lr_freight.balance
        },
        errorSchema.addChargeSchema
      );

      if (validationResult !== true) {
        setFormError(validationResult);
        return;
      }

      const payload = {
        type: form?.category ? parseInt(form.category) : "",
        sub_type: form?.sub_category ? parseInt(form.sub_category) : "",
        expense_category: form?.expense_category,
        amount: form?.amount.toString(),
        date: utils.convertToISO(form?.txn_date, true),
        account_category: form?.account_category ? parseInt(form.account_category) : "",
        account_sub_category: form?.account_sub_category ? parseInt(form.account_sub_category) : "",
        account_id: form?.account_id || "",
        description: form?.description,
        vendor_bank_account: bankDetails ? bankDetails._id : "",
        lr_id: lrDetails?._id,
        trip_id: tripId,
        company_id: form?.company_id,
        is_approval: approve,
        file: form?.file,
      };

      approve === 0 ? setIsLoadding(true) : setIsLoadingSave(true);

      const res = await dispatch(addTransationConsignor(payload));

      if (res?.payload?.responseCode === 200) {
        toast.success("Transaction added successfully");
        callBackCharge();
      } else {
        toast.error(res?.payload?.responseMessage || "Failed to add transaction");
      }
    } catch (error) {
      console.error("Submit error:", error);
      toast.error("Error submitting transaction");
    } finally {
      setIsLoadding(false);
      setIsLoadingSave(false);
    }
  }, [form, bankDetails, lrDetails?._id, tripId, dispatch, callBackCharge]);

  const documentRemove = useCallback((index) => {
    setForm(prev => ({
      ...prev,
      file: prev.file.filter((_, i) => i !== index)
    }));
  }, []);

  const modifyProps = {
    ...props,
    modalTitle: form?.sub_category == 1 ? "Add Advance Freight" : "Add Balance Freight",
    onSubmit: onSubmitFreight,
    isLoadding: isLoadding,
    disabled: isLoadding || isLoadingSave,
    isLoadingSave: isLoadingSave,
    saveButton: form?.account_sub_category == 27,
    tripApprovalPermission: bankRequiredDetails?.trip_payment_approval || 0
  };

  return (
    <div>
      <CommonCanvas {...modifyProps}>
        <div className="offcanvas-body">
          <div className="_lrCl_offCavBody">
            <div className="_othrExp_recBx">
              <div className="checkBx_lv">
                {freightTypeList.map((i) => (
                  <div className="_dualCheckr_bx" key={i.value}>
                    <input
                      className="form-check-input"
                      id={i.value}
                      type="radio"
                      name="sub_category"
                      checked={i.value == form.sub_category}
                      value={i.value}
                      onChange={({ target: { name, value } }) =>
                        handleOnChange(name, value)
                      }
                    />
                    <label htmlFor={i.value} className="form-check-label">
                      {i?.label}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <div className="_clPay_flex">
              <div className="singleDiv">
                <CommonInput
                  type="text"
                  label="Amount (₹)"
                  placeholder="Amount"
                  name="amount"
                  className="__rupeeSymbol"
                  rupeeSymbol={true}
                  value={form.amount}
                  // onChange={({ target: { name, value } }) => {
                  //   if (/^\d*$/.test(value)) {
                  //     handleOnChange(name, value);
                  //   }
                  // }}

                  onChange={({ target: { name, value } }) => {
                    if (/^0[0-9]/.test(value)) {
                      value = value.replace(/^0+/, ''); // "01" → "1"
                    }

                    // Allow "0." for decimals but not "0x" where x is digit
                    if (value === "0") {
                      handleOnChange(name, value);
                      return;
                    }
                    handleOnChange(name, value)
                  }}
                  onKeyDown={handleKeyDown}
                  maxLength={10}
                  focus={!!formError?.amount}
                  error={formError.amount}
                />
              </div>

              <div className="singleDiv">
                <CommonDatePicker
                  name="date"
                  label="Transaction Date"
                  startDate={form?.txn_date}
                  setStartDate={(data) => {
                    handleOnChange("txn_date", data);
                  }}
                  error={formError?.txn_date}
                  focus={!!formError?.txn_date}
                />
              </div>

              <div className="singleDiv">
                <CommonInput
                  type="text"
                  label="Description"
                  placeholder="Description"
                  name="description"
                  value={form?.description}
                  onChange={({ target: { name, value } }) => {
                    handleOnChange(name, value);
                  }}
                  focus={!!formError?.description}
                  error={formError.description}
                />
              </div>

              <div className="singleDiv">
                <div className="_payMode_hed">
                  <h4>Payment Mode</h4>
                  {freigtAccount.map((i) => (
                    <button
                      key={i.value}
                      className={`_baseSpan ${i?.value == form?.account_sub_category
                        ? ""
                        : "_bspDisable"
                        }`}
                      disabled={accountLoading}
                      name="account_sub_category"
                      value={i.value}
                      onClick={({ target: { name, value } }) => {
                        handleOnChange(name, value);
                        setAccountType(value);
                      }}
                    >
                      {i.label}
                    </button>
                  ))}
                </div>
              </div>

              {form?.account_sub_category != 11 && (
                <>
                  {!accountLoading ? (
                    <div className="singleDiv">
                      <CustomSelect
                        label="Select Account"
                        name="account_id"
                        onSelect={(data) => {
                          handleOnChange("account_id", data.value);
                          setBankRequiredDetails(data)
                        }}
                        value={
                          form?.account_id
                            ? accountList?.find((i) => i.value == form?.account_id) || { label: "", value: "" }
                            : { label: "", value: "" }
                        }
                        options={accountList}
                        focus={!!formError?.account_id}
                        error={formError.account_id}
                      />
                    </div>
                  ) : (
                    <SkeletonInput isLoading={accountLoading} />
                  )}
                </>
              )}

              {form?.account_sub_category == 11 && (
                <div>
                  Driver - {globTripDetails?.driver_id?.name}
                </div>
              )}

              <div className="singleDiv">
                <div className="_attatchmentBxs">
                  <h4>Attachment</h4>
                  <div className="_athBxs">
                    <input
                      type="file"
                      id="_fileUpload"
                      onClick={(e) => {
                        if (form?.file?.length >= 5) {
                          e.preventDefault(); // stop opening file dialog
                          toast.error("You can upload only 5 files");
                        }
                      }}
                      onChange={(e) => handleFileChange(e)}
                      accept="image/gif,image/jpeg,image/png"
                    />
                    <label htmlFor="_fileUpload" className="_uploadBtn">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="19"
                        viewBox="0 0 20 19"
                        fill="none"
                      >
                        <path
                          d="M5 0C6.28846 7.44425e-05 7.52716 0.497542 8.45778 1.38866C9.38839 2.27978 9.93908 3.49575 9.995 4.783L10 5V16C10.0008 16.7809 9.69698 17.5313 9.15323 18.0918C8.60948 18.6523 7.86861 18.9787 7.08804 19.0016C6.30747 19.0245 5.54873 18.7422 4.97303 18.2145C4.39733 17.6869 4.05006 16.9556 4.005 16.176L4 16V6C4.00028 5.74512 4.09788 5.49997 4.27285 5.31463C4.44782 5.1293 4.68695 5.01776 4.94139 5.00283C5.19584 4.98789 5.44638 5.07067 5.64183 5.23426C5.83729 5.39785 5.9629 5.6299 5.993 5.883L6 6V16C6.00028 16.2549 6.09788 16.5 6.27285 16.6854C6.44782 16.8707 6.68695 16.9822 6.94139 16.9972C7.19584 17.0121 7.44638 16.9293 7.64183 16.7657C7.83729 16.6021 7.9629 16.3701 7.993 16.117L8 16V5C8.00075 4.21909 7.69698 3.46867 7.15323 2.90818C6.60948 2.34769 5.86861 2.02132 5.08804 1.9984C4.30747 1.97548 3.54873 2.25784 2.97303 2.78546C2.39733 3.31309 2.05006 4.0444 2.005 4.824L2 5V14C1.99972 14.2549 1.90212 14.5 1.72715 14.6854C1.55218 14.8707 1.31305 14.9822 1.05861 14.9972C0.804163 15.0121 0.553621 14.9293 0.358167 14.7657C0.162714 14.6021 0.0371036 14.3701 0.00699997 14.117L0 14V5C0 3.67392 0.526784 2.40215 1.46447 1.46447C2.40215 0.526784 3.67392 0 5 0ZM13 14H15C15.2549 14.0003 15.5 14.0979 15.6854 14.2728C15.8707 14.4478 15.9822 14.687 15.9972 14.9414C16.0121 15.1958 15.9293 15.4464 15.7657 15.6418C15.6021 15.8373 15.3701 15.9629 15.117 15.993L15 16H13C12.7451 15.9997 12.5 15.9021 12.3146 15.7272C12.1293 15.5522 12.0178 15.313 12.0028 15.0586C11.9879 14.8042 12.0707 14.5536 12.2343 14.3582C12.3979 14.1627 12.6299 14.0371 12.883 14.007L13 14ZM13 10H18.5C18.7549 10.0003 19 10.0979 19.1854 10.2728C19.3707 10.4478 19.4822 10.687 19.4972 10.9414C19.5121 11.1958 19.4293 11.4464 19.2657 11.6418C19.1021 11.8373 18.8701 11.9629 18.617 11.993L18.5 12H13C12.7451 11.9997 12.5 11.9021 12.3146 11.7272C12.1293 11.5522 12.0178 11.313 12.0028 11.0586C11.9879 10.8042 12.0707 10.5536 12.2343 10.3582C12.3979 10.1627 12.6299 10.0371 12.883 10.007L13 10ZM13 6H18.5C18.7549 6.00028 19 6.09788 19.1854 6.27285C19.3707 6.44782 19.4822 6.68695 19.4972 6.94139C19.5121 7.19584 19.4293 7.44638 19.2657 7.64183C19.1021 7.83729 18.8701 7.9629 18.617 7.993L18.5 8H13C12.7451 7.99972 12.5 7.90212 12.3146 7.72715C12.1293 7.55218 12.0178 7.31305 12.0028 7.05861C11.9879 6.80416 12.0707 6.55362 12.2343 6.35817C12.3979 6.16271 12.6299 6.0371 12.883 6.007L13 6ZM13 2H18.5C18.7549 2.00028 19 2.09788 19.1854 2.27285C19.3707 2.44782 19.4822 2.68695 19.4972 2.94139C19.5121 3.19584 19.4293 3.44638 19.2657 3.64183C19.1021 3.83729 18.8701 3.9629 18.617 3.993L18.5 4H13C12.7451 3.99972 12.5 3.90212 12.3146 3.72715C12.1293 3.55218 12.0178 3.31305 12.0028 3.05861C11.9879 2.80416 12.0707 2.55362 12.2343 2.35817C12.3979 2.16271 12.6299 2.0371 12.883 2.007L13 2Z"
                          fill="#1956F6"
                        />
                      </svg>
                      <span>{loading ? "Uploading..." : "Add File"}</span>
                    </label>
                    {formError?.file && (
                      <span className="input_drop_error">
                        {formError?.file}
                      </span>
                    )}
                  </div>
                  <div className="img_fnex_src">
                    {form?.file?.length > 0 &&
                      form.file.map((el, index) => (
                        <div className='pos-relative' key={index}>
                          <img
                            className='_pdfIcon_sigxe'
                            src={`${masterData?.s3_url}${el?.path}`}
                            alt={el?.filename || `Document ${index + 1}`}
                          />
                          <span className='_clDel_icon'>
                            <IoCloseCircle onClick={() => documentRemove(index)} />
                          </span>
                        </div>
                      ))
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="_balSuccess">
            <p>Party Balance:</p>

            <p>
              {/* {(
                          props?.transactionList?.freight_summary
                            ?.freight_summary?.balance - form?.amount
                        ).toFixed(2)} */}
              {form?.sub_category == 2
                ? `${lrDetails.lr_freight.balance} - ${form?.amount || 0} = ${Number(lrDetails.lr_freight.balance) - Number(form?.amount)
                }`
                : `${lrDetails.lr_freight.balance} - ${form?.amount || 0} = ${Number(lrDetails.lr_freight.balance) - Number(form?.amount)
                }`}

            </p>
          </div>
        </div>
      </CommonCanvas>
    </div>
  );
};

export default AddChargeModal;
